// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".limitshow[data-v-8fd41aa0]{max-width:10em;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
